import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { Chart } from "react-google-charts";
import { busca_notas_no_prazo_rede, busca_prazo_avaliacao } from "../../services/api";

const Prazo_Rede = (props) => {

    let avaliacao = props.av;

    const [data2, setData2] = useState([]);
    // const [avaliacao, setAvaliacao] = useState("AS1");

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    const fetchData = async () => {
        try {
            const response = await busca_notas_no_prazo_rede(avaliacao);
            console.log("PAREDE2", response)
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    const avaliacaoOptions = [
        "AS1", "AQ1", "AP1", "AV1",
        "AS2", "AQ2", "AP2", "AV2",
        "AS3", "AQ3", "AP3", "AV3",
        "AS4", "AQ4", "AP4", "AV4",
    ];


    useEffect(() => {
        fetchData();
    }, [avaliacao]);

    let chartDataFid = [];

    if (typeof data2 !== 'undefined') {
        chartDataFid = data2.map((item, index) => {
            let percentprazo = (parseFloat(item.notas_no_prazo) * 100) / parseFloat(item.notas_esperadas);
            const row = [unidades[parseInt(item.unidade)]];
            row.push(parseFloat(percentprazo) || 0);
            return row;
        });
    };

    // const handleAvaliacaoChange = (event) => {
    //     setAvaliacao(event.target.value);
    // };

    // chartDataFid.sort()
    chartDataFid.sort();
    chartDataFid.unshift(['Unidade', '%']);


    const options = {
        allowHtml: true,

    };
    const formatters = [
        {
            type: "NumberFormat",
            column: 1,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 1,
            ranges: [
                [0, 15, "white", "black"],
                [15, 30, "white", "darkred"],
                [30, 50, "white", "red"],
                [50, 75, "white", "orange"],
                [75, 92, "black", "yellow"],
                [92, 100, "black", "lightgreen"],
                [100, 101, "white", "green"],
            ],
        },
    ];

    return (
        <div className="Percent_unidade" style={{ border: "1px solid #ccc", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "20px", borderRadius: "8px" }}>
            <label>
                <h5>Total de Lançamento no Prazo - {avaliacao}</h5>
            </label>
            <Chart
                chartType="Table"
                width="100%"
                data={chartDataFid}
                options={options}
                formatters={formatters}
            />
        </div>
    )
};
export default Prazo_Rede;
